// Senha da tela de criar o administrador (G1). Espelha o backend para o admin
// nunca ver o erro do Devise em ingles: devise.rb (password_length 6..128) +
// secure_password.rb (1 maiuscula, 1 minuscula, 1 numero, 1 simbolo) e a gem
// devise-secure_password, que so conhece A-Z, a-z, 0-9 e os SIMBOLOS abaixo e
// recusa qualquer outro caractere (acento, c-cedilha, emoji: "unknown", max 0).
// Quem valida de verdade continua sendo o backend.
export const TAMANHO_MINIMO = 6;
export const TAMANHO_MAXIMO = 128;

// Support::String::CharacterCounter da gem (o espaco tambem conta).
export const SIMBOLOS = ' !@#$%^&*()_+-=[]{}|"/\\.,`<>:;?~\'';

export const NOMES_DA_FORCA = ['', 'fraca', 'razoável', 'boa', 'forte'];

const ehSimbolo = c => SIMBOLOS.includes(c);
const ehConhecido = c => /[A-Za-z0-9]/.test(c) || ehSimbolo(c);

// Cada regra da lista da tela, na ordem em que aparece. `invalidos` sao os
// caracteres que o backend recusa (sem repetir), para a dica dizer quais.
export const regrasDaSenha = senha => {
  const chars = Array.from(String(senha || ''));
  return {
    tamanho: chars.length >= TAMANHO_MINIMO && chars.length <= TAMANHO_MAXIMO,
    maiuscula: chars.some(c => /[A-Z]/.test(c)),
    minuscula: chars.some(c => /[a-z]/.test(c)),
    numero: chars.some(c => /[0-9]/.test(c)),
    simbolo: chars.some(ehSimbolo),
    invalidos: [...new Set(chars.filter(c => !ehConhecido(c)))],
  };
};

export const REGRAS = [
  'tamanho',
  'maiuscula',
  'minuscula',
  'numero',
  'simbolo',
];

export const senhaValida = senha => {
  const regras = regrasDaSenha(senha);
  return REGRAS.every(r => regras[r]) && !regras.invalidos.length;
};

// 0 a 4. So chega a "boa" (3) com todas as regras cumpridas; "forte" (4)
// com 10 caracteres ou mais. Sem cumprir: "fraca" ate 2 regras, depois
// "razoavel".
export const forcaDaSenha = senha => {
  const s = String(senha || '');
  if (!s) return 0;
  if (senhaValida(s)) return Array.from(s).length >= 10 ? 4 : 3;
  const regras = regrasDaSenha(s);
  const cumpridas = REGRAS.filter(r => regras[r]).length;
  return cumpridas <= 2 ? 1 : 2;
};
